import { AddRounded } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Card } from '../Card';
import { isFunction } from 'lodash';

interface Props {
    title?: string;
    description?: string;
    buttonText?: string;
    onClick?: () => void;
}

const cardStyles = { textAlign: 'center', py: 3 };

export const NoListYet = ({
    title = 'Empty list',
    description = 'It’s time to create a new one.',
    buttonText = 'Create new',
    onClick,
}: Props) => (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <Card sx={cardStyles}>
            <Typography variant="h4">{title}</Typography>
            <Typography my={2}>{description}</Typography>
            {isFunction(onClick) && (
                <Button variant="outlined" startIcon={<AddRounded />} onClick={onClick}>
                    {buttonText}
                </Button>
            )}
        </Card>
    </Box>
);
